var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"circle-number__container"},[(_vm.icon)?_c('NebulaIcon',{staticClass:"stepper__icon",attrs:{"symbol-id":_vm.icon,"size":"s"}}):_c('span',{staticClass:"circle-number__glyph"},[_vm._v(" "+_vm._s(_vm.number)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }